import { Route, Routes } from 'react-router-dom';
import './App.css';
import PageInicio from './components/inicio/PageInicio';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Nosotros from './components/nosotros/Nosotros';
import Clientes from './components/clientes/Clientes';
import Productos from './components/productos/Productos';
import Servicios from './components/servicios/Servicios';
import Cursos from './components/cursos/Cursos';
import Contacto from './components/contacto/Contacto';
//import Curso from './components/paginaCurso/Curso';//
import Geontracker from './components/paginaProducto/geontracker/Geontracker';
//import WhatsappBot from './components/paginaProducto/whatsappBot/WhatsappBot';//
import EvoScadaServer from './components/paginaProducto/evoScadaServer/EvoScadaServer';
import FactoryScada from './components/paginaProducto/factoryScada/FactoryScada';
import SistemaDeIntervencionYControl from './components/paginaProducto/sistemaDeIntervencionYControl/SistemaDeIntervencionYControl';
import InteractiveVoiceResponse from './components/paginaProducto/interactiveVoiceResponse/InteractiveVoiceResponse';
import BusinessSolution from './components/paginaProducto/businessSolution/BusinessSolution';
import Politicas from './components/politicas/Politicas';
import LandingGMAO from './components/landing/LandingGmaoSsc';


import ProductPageRenderer from './components/productPageLayout/ProductPageRenderer';
import { Navigate } from "react-router-dom";


function App() {

  return (
    <div className="app">
      {
        <>
          <Navbar />
          <Routes>
            <Route path='/' Component={PageInicio} />
            <Route path='/nosotros' Component={Nosotros} />
            <Route path='/clientes' Component={Clientes} />
            <Route path='/productos' Component={Productos} />
            <Route path='/servicios' Component={Servicios} />
            <Route path='/cursos' Component={Cursos} />
            <Route path='/contacto' Component={Contacto} />
            {/* <Route path='/cursos/:id' Component={Curso} />*/}
            <Route path='/politicas' Component={Politicas} />        
            <Route path='/productos/business-solution' Component={BusinessSolution} />
            <Route path='/productos/interactive-voice-response' Component={InteractiveVoiceResponse} />
            <Route path='/productos/sistema-de-intervencion-y-control' Component={SistemaDeIntervencionYControl} />
            <Route path='/productos/factory-scada' Component={FactoryScada} />
            <Route path='/productos/evo-scada-server' Component={EvoScadaServer} />
            <Route path='/productos/geontracker' Component={Geontracker} />                       
            <Route path="/landing/landing-gmao" Component={LandingGMAO} />
            {/* <Route path='/productos/whatsapp-bot' Component={WhatsappBot} />*/}
            <Route path="/productos/businessSolution" element={<ProductPageRenderer product="business-solution" />}/>
            <Route path="/productos/smartsen" element={<ProductPageRenderer product="smartsen" />}/>
            <Route path="/productos/smartSsc" element={<ProductPageRenderer product="smartssc" />}/>
            <Route path="/productos/smartSuite" element={<ProductPageRenderer product="smartsuite" />}/>
            <Route path="/productos/ssc-enterprise" element={<ProductPageRenderer product="ssc-enterprise" />}/>
            <Route path="/productos/sistema-de-intervencion-y-control" element={<Navigate to="/productos/ssc-enterprise" replace />}/>

            <Route path="/productos/smartiot" element={<ProductPageRenderer product="smartiot" />} />
            <Route path="/productos/factory-scada" element={<ProductPageRenderer product="factoryscada" />} />
            <Route path="/productos/evo-scada-server" element={<ProductPageRenderer product="evoscadaserver" />} />
            <Route path="/productos/ivr" element={<ProductPageRenderer product="ivr" />} />
            <Route path="/productos/geontracker" element={<ProductPageRenderer product="geontracker" />} />
            <Route path="/productos/whatsapp" element={<ProductPageRenderer product="whatsapp" />} />
            <Route path="/productos/consejar" element={<ProductPageRenderer product="consejar" />} />
            <Route path="/productos/syncFlow" element={<ProductPageRenderer product="syncflow" />} />

          </Routes>
          <Footer />
        </>
      }
    </div>
  );
}

export default App;
